var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-bottom-menu fixed bottom-0 right-0 w-full pointer-events-none flex items-center pb-ios md-pb-0"},[_c('div',{staticClass:"flex-1 mr-18 flex justify-end"},[_vm._t("left")],2),_c('div',{staticClass:"w-40"},[_vm._t("center")],2),_c('div',{staticClass:"flex-1 ml-18 md-hidden"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }